import { FilterFn, FilterFns, RowData } from '@tanstack/react-table';
import { ComponentType } from 'react';
import { registerFilterFn } from './filterFns';
import { FilterInputProps } from './FilterInputProps';
import { registerFilterInput } from './filterInputs';

export const registerTableFilter = <D extends RowData>(
  name: keyof FilterFns,
  filterFn: FilterFn<D>,
  filterInputComponent: ComponentType<FilterInputProps>
) => {
  registerFilterFn(name, filterFn);
  registerFilterInput(name, filterInputComponent);
};
